var exports = {
  "kL": "xa15a2ab7--1f5fc1--container",
  "Kk": "xa15a2ab7--1f5fc1--icon",
  "UE": "xa15a2ab7--1f5fc1--arrow",
};

module.exports = exports;
